<template>
  <div>
    <v-card class="mb-7" flat>
      <v-card-title> Termos e condições </v-card-title>

      <v-card-text>
        <div class="mb-4">
          Por favor, leia e aceite os seguintes termos e condições para poder
          continuar.
        </div>

        <iframe
          class="terms"
          src="/temos-segurado.htm"
          frameborder="0"
        ></iframe>

        <v-checkbox
          v-model="accepted"
          label="Eu aceito os termos e condições"
          :color="insurer.color"
        ></v-checkbox>
      </v-card-text>
    </v-card>

    <v-btn
      :color="insurer.color"
      :dark="accepted"
      @click="$emit('continue')"
      :disabled="!accepted"
    >
      Continuar
    </v-btn>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    insurer: Object,
  },

  data() {
    return {
      accepted: false,
      terms: `Ao iniciar e submeter a participação de sinistro através desta plataforma, o Segurado declara que leu, compreendeu e aceita integralmente os presentes Termos e Condições.

1. Objecto

Os presentes Termos e Condições regulam a utilização da plataforma digital destinada à participação de sinistros, bem como o envio de informações, declarações, documentos e demais elementos necessários à análise do sinistro por parte da Seguradora.

2. Prestação de Informações

2.1. O Segurado compromete-se a fornecer informações verdadeiras, completas e exactas, descrevendo os factos tal como ocorreram, de acordo com o seu conhecimento.

2.2. O envio de informações falsas, incompletas ou omissas poderá comprometer a análise do sinistro e dar origem à recusa da cobertura, nos termos da legislação aplicável e das condições da apólice.

2.3. Não é exigido ao Segurado qualquer conhecimento técnico ou pericial, devendo apenas relatar os factos de forma clara e de boa-fé.

3. Documentos e Provas

3.1. O Segurado poderá ser solicitado a submeter documentos, fotografias, vídeos ou outros elementos de suporte considerados necessários para a correcta análise do sinistro.

3.2. A submissão destes elementos não implica, por si só, o reconhecimento da responsabilidade da Seguradora ou a aceitação da cobertura do sinistro.

3.3. A Seguradora reserva-se o direito de solicitar informações ou documentos adicionais, sempre que tal se revele necessário.

4. Análise do Sinistro

4.1. Após a submissão da participação, as informações fornecidas serão analisadas pela equipa responsável.

4.2. O estado do sinistro poderá ser acompanhado através da plataforma disponibilizada, utilizando os meios de acesso indicados ao Segurado.

4.3. Os prazos de análise e decisão dependem da natureza do sinistro, da complexidade do caso e da recepção de todos os elementos necessários.

5. Responsabilidade do Segurado

5.1. O Segurado é responsável pelo conteúdo das informações e dos documentos submetidos através da plataforma.

5.2. O Segurado declara ter legitimidade para efectuar a participação do sinistro e para fornecer os dados apresentados.

5.3. A utilização indevida da plataforma ou a prestação de informações fraudulentas poderá dar origem às consequências legais previstas.

6. Protecção de Dados

6.1. Os dados pessoais recolhidos no âmbito deste processo serão tratados de forma confidencial e utilizados exclusivamente para a gestão, análise e regularização do sinistro, nos termos da legislação aplicável em matéria de protecção de dados.

6.2. O Segurado autoriza o tratamento dos dados fornecidos para os fins acima descritos.

7. Limitação de Responsabilidade

7.1. A utilização da plataforma não garante, por si só, a aceitação do sinistro ou o pagamento de qualquer indemnização.

7.2. A decisão final sobre a cobertura do sinistro será tomada de acordo com as condições contratuais da apólice e a legislação em vigor.

8. Disposições Finais

8.1. A submissão da participação implica a aceitação integral dos presentes Termos e Condições.

8.2. A Seguradora reserva-se o direito de actualizar ou alterar estes Termos e Condições, sempre que necessário, sendo as alterações devidamente comunicadas através da plataforma.

Declaração Final

Ao prosseguir com este processo, o Segurado confirma que as informações prestadas são verdadeiras e que compreende que a sua participação será objecto de análise, não constituindo garantia de aceitação do sinistro.
`,
    };
  },

  methods: {},

  computed: {},
};
</script>

<style lang="scss" setup>
.terms {
  width: 100%;
  height: 300px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
</style>
